module.exports = __webpack_public_path__ + "img/my_icon.ba2dbd05.png";